/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: ITAT Time
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList'
import themeConfig from '@/../themeConfig.js'
import colors from '@/../themeConfig.js'

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid         : 0,          // From Auth
  displayName : 'Display Name', // From Auth
  about       : 'Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.',
  status      : 'online',
  userRole    : 'admin',
  currentWork : 'Working on Vue'
}

// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
  const mq = function (query) {
    return window.matchMedia(query).matches
  }

  if (('ontouchstart' in window) || window.DocumentTouch) {
    return true
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
  return mq(query)
}

const baseModals = {
  SettingsModal:{
    show:false,
    content:{
      header:'Settings',
      body:{
      },
      details:null
    }
  },
  AlertModal:{
    show:false,
    content:{
      header:'Alert',
      body:{
      },
      details:null
    }
  }
}

const timeEntryPromptDefaults = {
  active: false,
  title: 'Create New Task Entry',
  taskName: '',
  clientName: 'Client Name',
  clientCategory: 'Client Category',
  startTime: new Date(),
  endTime: new Date(),
  description: '',
  error: 'Fields cannot be empty.',
  clientID: null,
  projectID: null,
  categoryID: null,
  action: 'create' //create, edit, clockout
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  photoURL    : 'data:image/jpeg;base64,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',
  dbTimeFormatting        : 'YYYY-MM-DD\'T\'HH:mm:ss.SSSz',
  AppActiveUser           : userDefaults,
  bodyOverlay             : false,
  isVerticalNavMenuActive : true,
  is_touch_device         : is_touch_device(),
  mainLayoutType          : themeConfig.mainLayoutType || 'vertical',
  navbarSearchAndPinList,
  reduceButton            : themeConfig.sidebarCollapsed,
  verticalNavMenuWidth    : 'default',
  verticalNavMenuItemsMin : false,
  scrollY                 : 0,
  starredPages            : navbarSearchAndPinList['pages'].data.filter((page) => page.is_bookmarked),
  theme                   : themeConfig.theme || 'light',
  themePrimaryColor       : colors.primary,
  tokens: {},
  timeEntryList           : [],
  categoryList            : [],
  categoryListSOW         : [],
  clientList              : [],
  workerList              : [],
  modals                  : baseModals, 
  userLoggedIn            : false,
  receivedGlobalData      : false,
  timeEntryPrompt         : timeEntryPromptDefaults,
  timeEntryPromptTick     : 0,
  currentTimeEntry        : null,
  subTimeEntry            : null,
  isAdmin                 : false,
  activeRequests          : 0,
  devOpsPAT               : null,
  workerID                : null,
  authWorkerID            : null, //The authenticated user's id
  isClient                : false,
  isWorker                : false,
  projectList             : [],
  projectStatuses         : {},
  taskList                : [],
  taskListAll             : [],
  taskListUncompleted     : [],
  myTaskList              : [],
  allTaskList             : [],
  potentialExternalTask   : null,
  selectedProjectID       : -1,
  rawTotalHoursWorked     : [],
  rawTotalHoursWorkedWeekly: [],
  weeklyMileage           : 0,
  billableWeeklyWorked    : {},
  monthlyTable            : [],
  barChartQ1              : [],
  barChartQ2              : [],
  barChartQ3              : [],
  barChartQ4              : [],
  quarterlyData           : [],
  statsHours              : [],
  workerMessages          : [],
  taskStatusLookups       : [],
  sowStatusLookups        : [],
  sowOverageStatusLookups : [],
  sowSelectedTasks        : null,
  isEveryone              : false,
  jiraDomain              : 'itattestinguat',
  simulation              : -1,
  isSimulation            : false,
  sowList                 : [],
  mySOWLineItems          : [],
  devOpsReleaseDefs       : [],
  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null
}


export default state
